module.exports = __webpack_public_path__ + "6390bc7f0bff89756f500ccd5b761b0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/banner_optional_blau_still.jpg
// module id = 634
// module chunks = 0